import { Fields, AudioData } from "./reducer"
import { AudioFile, Language, AudioFormat } from "../../../../typings/types"

export enum ActionTypes {
    ADVANCE_STEPPER,
    REVERSE_STEPPER,
    UPDATE_TEXT,
    UPDATE_SELECTOR,
    ERROR,
    CLEAR_ERROR,
    SET_AUDIO,
    UPDATE_LANGUAGES,
    UPDATE_AUDIO_FORMATS,
    UPDATE_SOURCE_LANGUAGE,
    UPDATE_TARGET_LANGUAGE,
    UPDATE_TARGET_LANGUAGE_OPTIONS,
    RESET
}

interface advanceStepperAction {
    type: ActionTypes.ADVANCE_STEPPER
}

export const advanceStepper = (): advanceStepperAction => ({
    type: ActionTypes.ADVANCE_STEPPER
})

interface reverseStepperAction {
    type: ActionTypes.REVERSE_STEPPER
}

export const reverseStepper = (): reverseStepperAction => ({
    type: ActionTypes.REVERSE_STEPPER
})

export enum ManualPageError {
    EMPTY_INPUT = "Error, cannot be empty",
    NO_SRC_LANGUAGE_SELECTED = "Error must select a source language",
    NO_TARGET_LANGUAGE_SELECTED = "Error must select a target language",
    UNABLE_TO_FETCH_LANGUAGES = "Error, unable to fetch available languages for this user",
    FILE_NAME_EXISTS = "Error, file name already exists",
    TRANSLATION_ERROR = "Translation Error"
}

interface UpdateTextAction {
    id: Fields
    type: ActionTypes.UPDATE_TEXT
    value: string
}

export const updateText = (field: Fields, value: string): UpdateTextAction => ({
    id: field,
    type: ActionTypes.UPDATE_TEXT,
    value: value
})

interface UpdateSelectAction {
    id: Fields
    type: ActionTypes.UPDATE_SELECTOR
    value: string
}

export const updateSelect = (field: Fields, value: string): UpdateSelectAction => ({
    id: field,
    type: ActionTypes.UPDATE_SELECTOR,
    value: value
})

interface ErrorAction {
    id: Fields
    type: ActionTypes.ERROR
    value: string
    extra?: string
}

export const error = (field: Fields, value: ManualPageError | string): ErrorAction => ({
    id: field,
    type: ActionTypes.ERROR,
    value: value
})

interface ClearErrorAction {
    id: Fields
    type: ActionTypes.CLEAR_ERROR
}

export const clearError = (field: Fields): ClearErrorAction => ({
    id: field,
    type: ActionTypes.CLEAR_ERROR
})

interface SetAudioAction {
    id: AudioData
    type: ActionTypes.SET_AUDIO
    value: AudioFile
}

export const setAudio = (id: AudioData, value: AudioFile): SetAudioAction => ({
    id: id,
    type: ActionTypes.SET_AUDIO,
    value: value
})

interface UpdateAvailableLanguagesAction {
    type: ActionTypes.UPDATE_LANGUAGES
    value: Language[]
}

export const updateAvailableLanguages = (value: Language[]): UpdateAvailableLanguagesAction => ({
    type: ActionTypes.UPDATE_LANGUAGES,
    value: value
})

interface UpdateAvailableAudioFormats {
    type: ActionTypes.UPDATE_AUDIO_FORMATS
    value: AudioFormat[]
}

export const UpdateAvailableAudioFormats = (value: AudioFormat[]): UpdateAvailableAudioFormats => ({
    type: ActionTypes.UPDATE_AUDIO_FORMATS,
    value: value
})

interface UpdateSourceLanguage {
    type: ActionTypes.UPDATE_SOURCE_LANGUAGE
    value: number
}

export const updateSourceLanguage = (value: string): UpdateSourceLanguage => ({
    type: ActionTypes.UPDATE_SOURCE_LANGUAGE,
    value: parseInt(value)
})

interface UpdateTargetLanguage {
    type: ActionTypes.UPDATE_TARGET_LANGUAGE
    value: number
}

export const updateTargetLanguage = (value: string): UpdateTargetLanguage => ({
    type: ActionTypes.UPDATE_TARGET_LANGUAGE,
    value: parseInt(value)
})

interface Reset {
    type: ActionTypes.RESET
}
export const reset = (): Reset => ({
    type: ActionTypes.RESET
})

export type Action =
    | UpdateTextAction
    | ErrorAction
    | ClearErrorAction
    | UpdateSelectAction
    | SetAudioAction
    | UpdateAvailableLanguagesAction
    | UpdateAvailableAudioFormats
    | UpdateSourceLanguage
    | UpdateTargetLanguage
    | advanceStepperAction
    | reverseStepperAction
    | Reset
